module.exports = __webpack_public_path__ + "a40b7b107bbd8d82d1a5744aef44876b.svg";


//////////////////
// WEBPACK FOOTER
// ./images/back-button.svg
// module id = 85
// module chunks = 0